/**
 * Cherche une requête pour une url précise mise dans un cache précis
 * @param url
 * @param cacheName
 * @returns La requête depuis le cache
 */
async function match(url: string, cacheName: string): Promise<Response> {
  // eslint-disable-next-line no-console
  console.log(`Error getting data from network (${url}), trying cache fallback in '${cacheName}'`);
  try {
    const cache = await caches.open(cacheName);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (await cache.match(url))!;
  } catch (error) {
    console.error("Error retrieving data from cache", error);
    throw error;
  }
}

const cacheService = {
  match,
};
export default cacheService;
